import React from "react";
import styled from "styled-components";
import {device} from "../../../../styles/BreakPoints";
import FeaturedItem from "./featuredItem/FeaturedItem";

const Work = () => {
  const worklist = [
    {
      card: "/img/4u.png",
      name: "4U LOGISTICS",
      description:
        "A Logistics functionality based web application  where visitors can submit their quotations, drivers are applying for the driver role etc. Admin can perform opearations based on their permissions and super admin can set or update admin's permissions.",
      techStacks: [
        "Next.js",
        "Ant Design",
        "Tailwind CSS",
        "Axios",
        "RTK Query",
        "Express.js",
        "TypeScript",
        "Prisma",
        "Postgres",
        "Supabase",
      ],
      links: {
        live: "https://4u-frontend.vercel.app/",
        frontend: "https://github.com/tusharahmmed/4u_logistics_frontend",
        backend: "https://github.com/tusharahmmed/4u_logistics_backend",
      },
    },
    {
      card: "/img/shopperstale.png",
      name: "Shoppers' Tale",
      description:
        "An Ecommerce Retailer Shop where visitors can find preferred website list for shopping and send the product link via whatsApp and messenger. Admin has a general dashboard where he/she can add new sites, edit/update existing sites or delete a site",
      techStacks: [
        "React.js",
        "Styled Components",
        "Mantine Ui",
        "Firebase",
        "RTK Query",
      ],
      links: {
        live: "https://shopperstale.com/",
        frontend: "https://github.com/tusharahmmed/shopperstale",
        backend: "https://github.com/tusharahmmed/shopperstale-server",
      },
    },
    {
      card: "/img/archit.png",
      name: "Archit Builder",
      description:
        "A construction company's fully responsive web fontend developed from figma prototype.",
      techStacks: ["React.js", "Styled Components", "Npm", "Java Script"],
      links: {
        live: "https://architbuilders.netlify.app/",
        frontend: "https://github.com/tusharahmmed/archit-frontend",
      },
    },
    {
      card: "/img/medical.png",
      name: "Medical Clinic",
      description:
        "A medical clinic's fully responsive web fontend developed from figma prototype.",
      techStacks: ["React.js", "Swiper.js", "Npm", "Styled Components"],
      links: {
        live: "https://medicals.netlify.app/",
        frontend: "https://github.com/tusharahmmed/medical-center",
      },
    },
  ];
  return (
    <Container id="work">
      <Title>Some Things I’ve Built</Title>
      <ListWraper>
        {worklist.map((item, index) => {
          return <FeaturedItem key={index} data={item} />;
        })}
      </ListWraper>
    </Container>
  );
};

export default Work;

const Container = styled.section`
  margin: 0px auto;
  padding: 100px 0px;
  max-width: 1000px;

  @media ${device.mdM} {
    padding: 112px 0px 0px;
    margin-top: -103px;
  }
  @media ${device.mobileL} {
    padding: 80px 0px 0px;
    margin-top: -103px;
  }
`;

const Title = styled.h2`
  display: flex;
  align-items: center;
  position: relative;
  margin: 10px 0px 40px;
  width: 100%;
  font-size: clamp(26px, 5vw, var(--fz-heading));
  white-space: nowrap;
  font-weight: 600;
  color: var(--lightest-slate);
  line-height: 1.1;

  &::before {
    position: relative;
    counter-increment: section 1;
    content: "03.";
    margin-right: 10px;
    color: var(--green);
    font-family: ${(props) => props.theme.fonts.sf};
    font-size: clamp(var(--fz-md), 3vw, var(--fz-xl));
    font-weight: 400;
  }
  &::after {
    content: "";
    display: block;
    position: relative;
    width: 300px;
    height: 1px;
    margin-left: 20px;
    background-color: var(--lightest-navy);
  }
`;

const ListWraper = styled.ul`
  list-style: none;
  padding: 0px;
  margin: 0px;
`;
